// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__22VGu","footer":"ModalFilter_footer__1pLKp"};